import arrowBack from "@assets/images/arrow-left-circle-thin.svg";
import contactEmail from "@assets/images/email.svg";
import smLogoWhite from "@assets/images/sm-logo-inverted.svg";
import smLogo from "@assets/images/smo-logo-rounded.svg";
import { Box, Button, Checkbox, Grid, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { DEFAULT_INITIAL_SEARCH_DATA } from "@saleor/config";
import { ChangeEvent } from "@saleor/hooks/useForm";
import useNotifier from "@saleor/hooks/useNotifier";
import { maybe } from "@saleor/misc";
import useMallSearch from "@saleor/searches/useMallSearch";
import { SmopStatusEnum } from "@saleor/types/globalTypes";
import React, { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";

import MenuListComposition from "./ContactUsMenu";
export interface ContactUsFormData {
  company: string;
  concern: string;
  contactNumber: string;
  emailAddress: string;
  fullName: string;
  mallBranch: string;
  message: string;
  fileUpload: string;
}
export interface ContactUsCardProps {
  user;
  userAgree: any;
  validations;
  handleChange?: (event: ChangeEvent<any>) => void;
  handleToggle?: (event: ChangeEvent<any>) => void;
  onSubmit?(event: ContactUsFormData);
}
const useStyles = makeStyles(
  {
    agreement: {
      "& p": {
        "@media (max-width: 768px)": {
          fontSize: "12px"
        },
        fontSize: "10px",
        margin: 0
      },
      display: "flex",
      flexDirection: "row",
      margin: "10px 0 20px"
    },
    content: {
      "& form": {
        "@media (max-width: 1000px)": {
          width: "800px"
        },
        "@media (max-width: 1200px)": {
          width: "800px"
        },
        "@media (max-width: 768px)": {
          flexBasis: "100%",
          margin: "50px auto 0",
          maxWidth: "95%"
        },
        margin: "80px auto 0",
        width: "900px"
      },
      backgroundColor: "#fff",
      minHeight: "800px",
      width: "100%"
    },
    contentHeader: {
      "@media (max-width: 500px)": {
        alignItems: "flex-start",
        flexDirection: "column"
      },
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      padding: "20px 30px",
      position: "relative",
      width: "100%"
    },
    contentMenu: {
      display: "flex",
      width: "100%"
    },
    contentTop: {
      "& a": {
        "& img": {
          "@media (max-width: 768px)": {
            top: "0"
          },
          margin: "0 0 0 7px",
          position: "relative",
          top: "4px",
          width: "18px"
        },
        "@media (max-width: 768px)": {
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          margin: "5px 0 30px 0",
          width: "100%"
        },
        backgroundColor: "#DBDDFF",
        borderRadius: "6px",
        color: "#292D90",
        fontSize: "14px",
        fontWeight: "bold",
        padding: "12px 20px",
        textDecoration: "none"
      },
      "& h3": {
        "@media (max-width: 768px)": {
          margin: "10px 0 0"
        },
        color: "#FFCE21",
        fontSize: "40px",
        fontStyle: "italic",
        fontWeight: 900,
        margin: "10px 0 0"
      },
      "& p": {
        "@media (max-width: 768px)": {
          margin: "5px 0 20px 0"
        },
        color: "#fff",
        fontSize: "16px",
        margin: "5px 0 50px"
      },
      "@media (max-width: 768px)": {
        flexDirection: "column"
      },
      display: "flex",
      flexDirection: "row",
      padding: "0 30px"
    },
    err_fields: {
      backgroundColor: "#393636",
      color: "#fff",
      left: 0,
      padding: "10px 20px",
      position: "absolute",
      right: 0,
      top: "-40px",
      width: "100%"
    },
    fileField: {
      size: 10
    },
    formControl: {
      "& input": {
        paddingTop: "30px"
      },
      "& label": {
        backgroundColor: "#fff",
        margin: "5px 10px 0",
        paddingBottom: "3px",
        width: "200px"
      },
      "@media (max-width: 768px)": {
        width: "100%"
      },
      margin: "10px 0",
      padding: "0 10px",
      width: "100%"
    },
    formGrid: {
      "@media (max-width: 768px)": {
        flexBasis: "100%",
        maxWidth: "100%"
      }
    },
    formGridAgreement: {
      "@media (max-width: 768px)": {
        flexBasis: "95%",
        maxWidth: "95%"
      }
    },
    formLabel: {
      "& img": {
        marginRight: "10px"
      },
      "& span": {
        position: "relative",
        top: "-5px"
      },
      "@media (max-width: 500px)": {
        margin: "30px 80px 0 0"
      },
      color: "#fff",
      fontSize: "15px",
      fontWeight: 600,
      textDecoration: "none"
    },
    formLinks: {
      display: "flex",
      justifyContent: "center",
      width: "230px"
    },
    formSubmitBtn: {
      "& span": {
        color: "#0030FF"
      },
      "&:hover": {
        backgroundColor: "#BAC8FF",
        color: "#0030FF"
      },
      "@media (max-width: 768px)": {
        display: "grid",
        fontSize: "20px",
        margin: "20px auto 80px auto",
        padding: "10px 80px"
      },
      backgroundColor: "#BAC8FF",
      borderRadius: "6px",
      color: "#0030FF",
      cursor: "pointer",
      fontSize: "15px",
      margin: "20px 10px 10px",
      padding: "8px 60px",
      textTransform: "capitalize"
    },
    left_content: {
      "@media (max-width: 1000px)": {
        display: "block"
      },
      "@media (max-width: 800px)": {
        display: "none"
      },
      width: "40%"
    },
    loginLink: {
      borderColor: "#FFF",
      color: "#FFF",
      display: "inline-block",
      fontSize: "18px",
      margin: "0 20px 80px",
      position: "absolute",
      right: "150px",
      textDecoration: "none",
      top: "60px"
    },
    logoContainer: {
      display: "flex",
      flex: 1
    },
    mainPanel: {
      backgroundColor: "#96aaff",
      display: "flex",
      flexDirection: "column"
    },
    malls: {
      "& h3": {
        color: "#fff",
        fontSize: "20px",
        fontStyle: "italic",
        fontWeight: 600,
        margin: 0
      },
      backgroundColor: "#5C7FFE",
      borderRadius: "20px",
      margin: "40px auto 150px",
      padding: "20px",
      textAlign: "center",
      width: "80%"
    },
    root: {
      backgroundColor: "#FFF",
      flexGrow: 1
    },
    smFooter: {
      "& p": {
        "@media (max-width: 768px)": {
          maxWidth: "inherit"
        },
        color: "#fff",
        margin: "10px 0 0",
        maxWidth: "600px"
      },
      "@media (max-width: 768px)": {
        padding: "30px 20px"
      },
      minHeight: "200px",
      padding: "30px",
      width: "100%"
    },
    smFooterLogo: {
      width: "61px"
    },
    smLogo: {
      "@media (max-width: 768px)": {
        width: "90px"
      },
      width: "90px"
    },
    smWelcomeImage: {
      margin: "-150px 0 0",
      width: "600px"
    },
    welcome: {
      color: "#F0E700",
      fontSize: "60px",
      fontStyle: "italic",
      fontWeight: 800,
      margin: "0 0 10px"
    }
  },
  { name: "Contactus" }
);

const ContactUsCard: React.FC<ContactUsCardProps> = props => {
  const {
    handleChange,
    handleToggle,
    onSubmit,
    user,
    userAgree,
    validations
  } = props;
  const classes = useStyles(props);
  const { err } = validations;
  const searchMall = useMallSearch({
    variables: {
      ...DEFAULT_INITIAL_SEARCH_DATA,
      first: 100,
      status: SmopStatusEnum.ACT
    }
  });
  const [disabledBtn, setDisabledBtn] = useState(true);
  const handleCaptcha = value => {
    // console.log("Captcha value:", value);
    if (value) {
      setDisabledBtn(false);
    }
  };
  const activeMalls =
    searchMall &&
    searchMall.result &&
    searchMall.result.data &&
    searchMall.result.data.search &&
    searchMall.result.data.search.edges;
  const mallChoicesAdd = maybe(() => activeMalls, []).map(mall => ({
    label: mall.node.name,
    value: mall.node.id
  }));
  const mallChoices = [{ label: "", value: "" }, ...mallChoicesAdd];
  const concernsList = [
    {
      label: "Installation of Mobile App",
      value: "Installation of Mobile App"
    },
    {
      label: "Log-in / Username & Password",
      value: "Log-in / Username & Password"
    },
    {
      label: "Connection / Access Issues",
      value: "Connection / Access Issues"
    },
    { label: "Announcement", value: "Announcement" },
    { label: "Promotion Application", value: "Promotion Application" },
    { label: "Events / Important Dates", value: "Events / Important Dates" },
    {
      label: "CMSR (Certified Monthly Sales Report)",
      value: "CMSR (Certified Monthly Sales Report)"
    },
    {
      label: "SOA (Statement of Account)",
      value: "SOA (Statement of Account)"
    },
    { label: "Work Permit", value: "Work Permit" },
    { label: "Others", value: "Others" }
  ];
  const notify = useNotifier();
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    if (selectedImage) {
      setImageUrl(URL.createObjectURL(selectedImage));
    }
  }, [selectedImage]);

  return (
    <div className={classes.root}>
      <div className={classes.mainPanel}>
        <div className={classes.contentHeader}>
          <div className={classes.contentMenu}>
            <Link to="/" className={classes.logoContainer}>
              <img
                className={classes.smLogo}
                src={smLogo}
                alt="SM Header Logo"
              />
            </Link>
            <MenuListComposition />
          </div>
          <div className={classes.formLinks}>
            <Link className={classes.formLabel} to="/">
              <img src={arrowBack} alt="Back to Homepage" />
              <span>BACK TO HOME</span>
            </Link>
          </div>
        </div>
        <div className={classes.contentTop}>
          <div style={{ flex: 1 }}>
            <h3>SM Tenant Contact Center</h3>
            <p>
              We are here to help with any of your concerns. You can send your
              feedback to our tenant support email or you can message us
              directly using the form below.
            </p>
          </div>
          <div style={{ alignItems: "center", display: "flex" }}>
            <a href="mailto:tenantcare@smsupermalls.com">
              tenantcare@smsupermalls.com
              <img src={contactEmail} alt="Contact Us" />
            </a>
          </div>
        </div>
        <div className={classes.content}>
          <form
            id="contactForm"
            onSubmit={e => {
              e.preventDefault();
              onSubmit(user);
              setImageUrl("");
            }}
            noValidate
            autoComplete="off"
          >
            <Grid container>
              <Grid item xs={6} className={classes.formGrid}>
                <TextField
                  className={classes.formControl}
                  label="Full Name: *"
                  type="text"
                  name="fullName"
                  value={user.fullName || ""}
                  helperText={err.fullName ? err.fullName : ""}
                  error={err.fullName ? true : false}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <TextField
                  className={classes.formControl}
                  label="Company: *"
                  type="text"
                  name="company"
                  value={user.company || ""}
                  helperText={err.company ? err.company : ""}
                  error={err.company ? true : false}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <div style={{ padding: "10px" }}>
                  {activeMalls && (
                    <SingleSelectField
                      name="mallBranch"
                      choices={mallChoices}
                      label="Mall Branch: *"
                      value={user.mallBranch}
                      onChange={handleChange}
                      error={err.mallBranch ? true : false}
                    />
                  )}
                  {err.mallBranch ? (
                    <span
                      style={{
                        color: "#EC5D77",
                        display: "inherit",
                        fontSize: "0.75rem",
                        margin: "8px 10px 0"
                      }}
                    >
                      {err.mallBranch}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <TextField
                  className={classes.formControl}
                  label="Contact Number: *"
                  type="number"
                  name="contactNumber"
                  value={user.contactNumber || ""}
                  helperText={err.contactNumber ? err.contactNumber : ""}
                  error={err.contactNumber ? true : false}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true
                  }}
                  onKeyPress={event => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                <TextField
                  className={classes.formControl}
                  label="Email Address: *"
                  type="email"
                  name="emailAddress"
                  value={user.emailAddress || ""}
                  helperText={err.emailAddress ? err.emailAddress : ""}
                  error={err.emailAddress ? true : false}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </Grid>
              <Grid item xs={6} className={classes.formGrid}>
                <div style={{ padding: "10px" }}>
                  {
                    <SingleSelectField
                      name="concern"
                      choices={concernsList}
                      label="Your Concern: *"
                      value={user.concern}
                      onChange={handleChange}
                      error={err.concern ? true : false}
                    />
                  }
                  {err.concern ? (
                    <span
                      style={{
                        color: "#EC5D77",
                        display: "inherit",
                        fontSize: "0.75rem",
                        margin: "8px 10px 0"
                      }}
                    >
                      {err.concern}
                    </span>
                  ) : (
                    ""
                  )}
                </div>
                <TextField
                  className={classes.formControl}
                  label="Your Message: *"
                  type="textarea"
                  name="message"
                  value={user.message || ""}
                  helperText={err.message ? err.message : ""}
                  error={err.message ? true : false}
                  onChange={handleChange}
                  multiline
                  rows={5}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    margin: "10px"
                  }}
                >
                  <input
                    accept="image/jpeg, image/jpg, image/png"
                    color="primary"
                    type="file"
                    name="fileUpload"
                    id="select-image"
                    style={{ display: "none" }}
                    onChange={e => {
                      const file = e.target.files[0];
                      if (
                        file.type.includes("image/jpeg") ||
                        file.type.includes("image/jpg") ||
                        file.type.includes("image/gif") ||
                        file.type.includes("image/png")
                      ) {
                        if (file.size <= 8e6) {
                          setSelectedImage(file);
                        } else {
                          notify({
                            status: "error",
                            text: "File size cannot be greater than 8mb"
                          });
                        }
                      } else {
                        notify({
                          status: "error",
                          text: "File not supported"
                        });
                      }
                    }}
                  />
                  <label htmlFor="select-image">
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                    >
                      Upload Image
                    </Button>
                  </label>
                </div>
                <div>Format: JPEG, PNG, GIF and File Size Max of 8MB</div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    margin: "10px"
                  }}
                >
                  {imageUrl && selectedImage && (
                    <Box mt={2} textAlign="center">
                      <div>Image Preview:</div>
                      <img
                        src={imageUrl}
                        alt={selectedImage.name}
                        height="100px"
                      />
                    </Box>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px"
                  }}
                >
                  <ReCAPTCHA
                    sitekey="6LcxCH8dAAAAAHh-1blOx9U1sjbdPZJ-jk0Z7rl6"
                    onChange={handleCaptcha}
                  />
                </div>
              </Grid>
              <Grid item xs={8} className={classes.formGridAgreement}>
                <div className={classes.agreement}>
                  <Checkbox
                    name="agreement"
                    checked={userAgree}
                    onChange={() => handleToggle(userAgree)}
                  />
                  <p>
                    I give my consent to SM Supermalls and its affiliates to
                    process my personal data in order to address and render the
                    services I require from them. I understand that my personal
                    data will be processed in accordance with{" "}
                    <a
                      href="https://www.smmallsonline.com/privacy-policy"
                      target="_blank"
                    >
                      SM Supermall’s Privacy Policy
                    </a>
                    .
                  </p>
                </div>
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  className={classes.formSubmitBtn}
                  variant="contained"
                  color="primary"
                  disabled={disabledBtn}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
        <div className={classes.smFooter}>
          <Link to="/">
            <img
              alt="SM Footer Logo"
              src={smLogoWhite}
              className={classes.smFooterLogo}
            />
          </Link>
          <p>
            SM Malls Online is the newest online shopping app of SM Supermalls.
            Shop from trusted retail brands, restaurants, and Cyberzone. Have
            all your orders shipped with one delivery fee or choose to pick it
            up in-store. It’s your ultimate shopping companion, bringing the fun
            of SM Malling to your phone!
          </p>
        </div>
      </div>
    </div>
  );
};
ContactUsCard.displayName = "ContactUsCard";
export default ContactUsCard;
